import { ComponentProps } from 'react';
import { Loader } from './loader';
import { LoaderOverlay } from './loader-overlay';

type LoadingViewProps = Omit<ComponentProps<typeof LoaderOverlay>, 'children'>;

export function LoadingView(props: LoadingViewProps): JSX.Element {
  return (
    <LoaderOverlay {...props}>
      <Loader />
    </LoaderOverlay>
  );
}
